var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"land-home-carousel"},[_c('div',{staticStyle:{"width":"1200px","margin":"0 auto"}},[_c('div',{staticClass:"solution-banner-title"},[_vm._v("科技有温度  造价更美好")]),_c('div',{staticClass:"solution-banner-text"},[_vm._v("数字新成本解决方案以企业成本数据积累与应用的闭环打通为核心，"),_c('br'),_vm._v("赋能企业实现数据资产化、作业高效化、决策智能化，让每一个工程项目成功。")])])])])
}]

export { render, staticRenderFns }